{#if canAdminGeneral}
<Page contentAreaLayout="narrow">
    <PageHeader
        headingLevel="h1"
        title={i18n.courseDescription}
        backLinkText={i18n.backToOverview}
        backLinkUrl={courseUrl}
    />
    <div
        class="itsl-course-info-box itsl-course-info-box__edit-view"
        class:itsl-course-info-box__edit-view--locked={isFormLocked}>
        <CourseInfoBoxEditBanner
            {...i18n.banner}
            type={bannerType}
            bind:visible={showBanner}
        />
        <Form action="" name="itsl-course-info-box__edit-form">
            <SimpleRtfEditor
                ariaLiveUpdateType="polite"
                {errorMessage}
                {hasError}
                headingLevel={defaultEditorHeadingLevel}
                i18n={i18n.rtfEditor}
                label={i18n.description}
                labelHidden={true}
                languageSelectorEnable={false}
                skiplinkUrl={`#${teacherSectionId}`}
                bind:this={rtfEditor}
                on:change={onEditorChange}
            />

            {#if displayShowTeachers}
            <RadioGroup
                options={showTeachersOptions}
                name="showTeachers"
                id={teacherSectionId}
                label={i18n.showTeachers}
                bind:selected={showTeachers}
                useSmallRadioButtons={true}
            />
            {/if}

            <ButtonGroup>
                <Button
                    disabled={isFormLocked || hasError}
                    htmlType="submit"
                    large={true}
                    loading={isFormLocked}
                    text={i18n.save}
                    type="primary"
                    on:click={onFormSubmit}
                />
                <Button
                    disabled={isFormLocked}
                    htmlType="button"
                    large={true}
                    text={i18n.cancel}
                    type="secondary"
                    on:click={onFormCancel}
                />
            </ButtonGroup>
        </Form>
    </div>
</Page>
{/if}

<script>
    import { onMount } from "svelte";
    import { post } from "@itslearning/atlas/network/fetch";

    import Button from "@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte";
    import ButtonGroup from "@itslearning/prometheus/assets/inputs/ButtonGroup/v1/ButtonGroup.svelte";
    import Form from "@itslearning/prometheus/assets/inputs/Form/v1/Form.svelte";
    import Page from "@itslearning/prometheus/assets/templates/Page/v1/Page.svelte";
    import PageHeader from "@itslearning/prometheus/assets/patterns/PageHeader/v1/PageHeader.svelte";
    import RadioGroup from "@itslearning/prometheus/assets/inputs/RadioGroup/v1/RadioGroup.svelte";
    import SimpleRtfEditor from "@itslearning/prometheus/assets/nodes/SimpleRtfEditor/v1/SimpleRtfEditor.svelte";

    import CourseInfoBoxEditBanner from "./CourseInfoBoxEditBanner.svelte";
    import { courseDescriptionMaxLength, defaultEditorHeadingLevel, teacherSectionId } from "../../constants";
    import { isStringLengthValid, setRtfContent } from "../../utils";

    export let antiForgeryHeaderName;
    export let antiForgeryHeaderValue;
    export let canAdminGeneral;
    export let courseDescription;
    export let courseUrl;
    export let displayShowTeachers = true;
    export let i18n;
    export let showTeachers;
    export let updateCourseInfoBoxSettingsEndpointURL;

    /** @type {SimpleRtfEditor} */
    let rtfEditor;

    let bannerType = "info";
    let errorMessage = i18n.courseDescriptionTooLong;
    let hasError = false;
    let isFormLocked = false;
    let showBanner = false;

    onMount(() => setRtfContent(rtfEditor, courseDescription));

    $: showTeachersOptions = [
        { label: i18n.yes, id: "yes", value: true, disabled: isFormLocked },
        { label: i18n.no, id: "no", value: false, disabled: isFormLocked },
    ];

    const displayWarningBanner = () => {
        showBanner = true;
        bannerType = "warning";
    };

    const hideBanner = () => showBanner = false;

    const lockForm = () => isFormLocked = true;
    const unlockForm = () => isFormLocked = false;

    const onEditorChange = () => {
        courseDescription = JSON.stringify(rtfEditor.getData());
        hasError = !isStringLengthValid(courseDescription, courseDescriptionMaxLength);
    }

    const onFormCancel = () => window.location.href = courseUrl;
    const onFormSubmit = () => {
        hideBanner();
        lockForm();

        courseDescription = JSON.stringify(rtfEditor.getData());
        hasError = !isStringLengthValid(courseDescription, courseDescriptionMaxLength);

        if (hasError) {
            unlockForm();
            return;
        }

        post(
            updateCourseInfoBoxSettingsEndpointURL,
            { courseDescription, showTeachers },
            { headers: { [antiForgeryHeaderName]: antiForgeryHeaderValue }}
        ).then(() => {
            window.location.href = courseUrl;
        }).catch(() => {
            displayWarningBanner();
            unlockForm();
        });
    };
</script>
